import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useEffect} from "react";

const ParamsModal = {
    days: 0,
    force: false,
    c1: true,
    c2: true,
    c3: true,
}

// Criterios del punto 5 (checkbox)
const CRITERIA = [
    {name: "c1", label: "C1: nivel actual por encima del riesgo"},
    {name: "c2", label: "C2: previsión al final de la ruta"},
    {name: "c3", label: "C3: riesgo en la próxima ruta si no se recoge"},
];

const TabCriteriaModalMassiveData = ({show, setShow, setDynamicAssetsShow, items, dynamicAssets, stepsTabs}) => {
    const [params, setParams] = useState({...ParamsModal});

    const handleClose = () => {
        setShow(false);
    }
    const handleChange  = (e) => {
        let {name, value, type, checked} = e.target;
        if (type === "checkbox") {
            value = checked;
        }
        let _params = {...params};
        _params[name] = value;
        setParams(_params);
    }

    const updateDynamicAssets = (list, params) => {
        list.forEach((dyn) => {
            if (items.current.chosen.includes(dyn.asset_id)) {
                dyn.days = parseInt(params.days || 0);
                dyn.force = params.force;
                dyn.c1 = params.c1;
                dyn.c2 = params.c2;
                dyn.c3 = params.c3;
            }
        })
        return list
    }

    const handleAccept = (e) => {
        e.preventDefault();
        items.current.all = updateDynamicAssets(items.current.all, params);
        items.current.showed = updateDynamicAssets(items.current.showed, params);
        dynamicAssets.current = updateDynamicAssets(dynamicAssets.current, params);
        setDynamicAssetsShow([...items.current.showed])
        stepsTabs.setClassifyAssets(false);
        setShow(false);
    }

    useEffect(() => {
        if(show){
            setParams({...ParamsModal});
        }
    }, [show])

    return (
        <Modal show={show} onHide={handleClose} animation={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="sliders"/>
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">Modificar Parametros masivamente</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="ms-auto">
                        <div className="col-12 mt-4 mb-4 text-center">
                            <div className="mb-3">
                                <label htmlFor="mod-massive-days" className="form-label">Dias desde el ultimo vaciado (0 = no aplica)</label>
                                <input type="number" className="form-control text-end m-auto" style={{width: "100px"}} min="0"
                                       id="mod-massive-days" name="days" value={params.days} onChange={handleChange}/>
                            </div>
                        </div>
                        {CRITERIA.map((criterion) => (
                            <div key={criterion.name} className="col-12 mt-3 d-flex justify-content-center">
                                <div className="form-check" style={{minWidth: "320px"}}>
                                    <input className="form-check-input" type="checkbox"
                                           id={`mod-massive-${criterion.name}`} name={criterion.name}
                                           onChange={handleChange} checked={params[criterion.name]}/>
                                    <label className="form-check-label" htmlFor={`mod-massive-${criterion.name}`}>
                                        {criterion.label}
                                    </label>
                                </div>
                            </div>
                        ))}
                        <div className="col-12 mt-5 mb-4 d-flex justify-content-center">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox"
                                       id="mod-massive-force" name="force" onChange={handleChange} checked={params.force}/>
                                <label className="form-check-label" htmlFor="mod-massive-force">
                                    Forzar recogida
                                </label>
                            </div>
                        </div>
                        <div className="mt-5 text-end mb-5">
                            <div className="mt-5 d-flex justify-content-end align-right">
                                <button type="button" className="btn btn-secondary"
                                        onClick={handleClose}>Cancel
                                </button>
                                <button type="button" className="btn btn-primary ms-4" onClick={handleAccept}>Aceptar</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
        </Modal>
    )
}
export default TabCriteriaModalMassiveData